import ExplorerResults from "./ExplorerResults";

export default ExplorerResults;
